import { get, isEmpty, toLower } from "lodash"
import { createSelector } from "reselect"
import { createQueryStringSelector, getRawSelectedBase } from "selectors/queryString"
import { computeEditingFilter, computeAddedFilters } from "helpers/filters"
import { computeFilterOns } from "helpers/filters/filter-ons"
import { classificationsMap, computeClassifications } from "helpers/classification"
import { getStartDate } from "./dates"
import { getIsActive } from "./base"
import { getCurrency as getCurrencySelector } from "./index"
import { computeFilteredSegment, NORMALIZATION } from "helpers/segments"
import { createEffectiveFilterScopeSelectors, parseFilterScope } from "helpers/filter-scope"
import { VIEW_TYPES } from "helpers/base"

const EMPTY_ARRAY = []

export const getClassificationsValues = (state) => get(state, "global.data.classificationsValues.data")
export const getSecuritiesDescriptors = state => get(state, "modules.analyzeCompositeSecurity.securitiesDescriptors")
export const getFiltersVisible = state => get(state, "modules.analyzeCompositeSecurity.filtersVisible", false)
export const getRawEditingFilter = state => get(state, "modules.analyzeCompositeSecurity.editingFilter")
export const getFilter = createQueryStringSelector("filter")
const getNormalization = createQueryStringSelector("normalization", NORMALIZATION.CONTRIBUTION)
const getRawFilterScope = createQueryStringSelector("filterScope")
export const getFilterScope = (state, props) => parseFilterScope(getRawFilterScope(state, props))
const getRawClassifications = (state) => get(state, "global.data.classifications.data.classifications")
const getAssetFilters = state => get(state, "global.data.assetFilters.data")
const getAssetType = (_, props) => toLower(get(props, "params.assetType"))
const getCurrency = (state, props) => getCurrencySelector(state, props)

export const getClassifications = createSelector(
  [getRawClassifications, getStartDate],
  computeClassifications,
)

export const getClassificationsTiers = createSelector(
  [getRawClassifications, getStartDate],
  classificationsMap,
)

export const { getEffectiveFilterScope, getEffectiveNormalization } = createEffectiveFilterScopeSelectors({
  getFilterScope,
  getIsActive,
  getFilter,
  getNormalization,
})

export const getFilterOns = createSelector(
  [getAssetFilters, getFilter, getRawEditingFilter, getClassifications, getClassificationsValues, getAssetType, getRawSelectedBase, getEffectiveNormalization],
  (filters, currentFilter, editing, classifications, classificationsValues, assetType, selectedBase, effectiveNormalization) => {
    if (!filters || !assetType) {
      return EMPTY_ARRAY
    }
    const viewType = isEmpty(selectedBase) ? VIEW_TYPES.ABSOLUTE : VIEW_TYPES.ACTIVE
    return computeFilterOns(viewType, filters, currentFilter, editing, {}, classifications, classificationsValues, {}, assetType, effectiveNormalization)
  },
)

export const getEditingFilter = createSelector(
  [getFilter, getRawEditingFilter, getFilterOns, getSecuritiesDescriptors],
  computeEditingFilter,
)

export const getSegment = createSelector(
  [getFilter, getEffectiveNormalization],
  computeFilteredSegment,
)

export const getAddedFilters = createSelector(
  [getFilter, getFilterOns, getSecuritiesDescriptors, getClassifications, getClassificationsValues, getCurrency],
  (filter, filterOns, securitiesDescriptors, classificationsMetas, classificationsValues, currency) => {
    return computeAddedFilters(filter, filterOns, {
      securitiesDescriptors,
      classificationsInfos: {
        classificationsMetas,
        classificationsValues,
      },
      currency,
    })
  },
)
